/**
 * Força download de uma URL cross-origin (signed URL do MinIO/S3).
 *
 * O attr `download` em `<a>` é ignorado quando href é cross-origin — então
 * a gente baixa via fetch + blob URL (same-origin), e dispara o download via
 * `<a download>` com a blob URL.
 */
export async function downloadCrossOrigin(url: string, filename: string): Promise<void> {
  // `cache: 'no-store'` é OBRIGATÓRIO: a imagem/mídia já foi carregada antes por
  // um `<img>`/`<video>` em modo no-cors, que cacheia uma resposta OPACA (sem
  // headers CORS). Sem o no-store, este `fetch` (modo cors) reusa a entrada
  // opaca do cache → "TypeError: Failed to fetch". No R2/Cloudflare o sintoma
  // aparece; no MinIO não aparecia. O no-store força requisição de rede limpa.
  const res = await fetch(url, { cache: 'no-store' });
  if (!res.ok) throw new Error(`download failed: ${res.status}`);
  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
}
